function adjustBoxTitleHeight() {
    const screenWidth = window.innerWidth;
    const columnContainers = document.querySelectorAll(".column-container");
    columnContainers.forEach(columnContainer => {
        const columns = columnContainer.querySelectorAll(".column");
        let maxHeight = 0;
        if (screenWidth >= 749) {
            columns.forEach(function(col) {
                const title = col.querySelector(".column-title");
                if (title != null) {
                    const titleHeight = title.offsetHeight;
                    if (titleHeight > maxHeight) {
                        maxHeight = titleHeight;
                    }
                }
            });
            columns.forEach(function(col) {
                const title = col.querySelector(".column-title");
                if (title != null) {
                    title.style.minHeight = `${maxHeight}px`;
                }
            });
        }
    });
}
window.addEventListener('resize', adjustBoxTitleHeight);
window.addEventListener('load', adjustBoxTitleHeight);
adjustBoxTitleHeight();
